import { Directive, ElementRef, Renderer2, Inject, PLATFORM_ID, Input, OnInit, HostListener } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

import * as $ from 'jquery';

@Directive({
  	selector: '[appSlider]'
})
export class SliderDirective implements OnInit {

	@Input() currentConfig:any;
	autoPlay:boolean = true;
	intervalo:any;

	btnNext:any;
  	btnPrev:any;
  	currenUl:any;

  	constructor(
  		private renderer: Renderer2, 
  		private elmRef: ElementRef,
  		@Inject(PLATFORM_ID) private platformId: Object
  	){
  	}

  	@HostListener('change') ngOnChanges() {
  		this.fnInitSlider();
  		$(this.btnNext).css({"display":"flex"});
  		$(this.btnPrev).css({"display":"flex"});
  		if( !this.currentConfig.init ){
  			$(this.btnNext).css({"display":"none"});
  			$(this.btnPrev).css({"display":"none"});
  			$(this.btnNext).off("click");
  			$(this.btnPrev).off("click");
  			if( parseInt($(this.currenUl).css("marginLeft")) < 0 ){
  				$(this.currenUl).css({"marginLeft":0});
  			}
  		}else{
  			$(this.btnNext).off("click");
  			$(this.btnPrev).off("click");
  			$(this.btnPrev).bind('click', ()=>{						
				this.autoPlay = false;
				clearInterval( this.intervalo );
				this.fnPrev( this.currenUl );
			});

			$(this.btnNext).bind('click', ()=>{
				this.autoPlay = false;
				clearInterval( this.intervalo );
				this.fnNext( this.currenUl );
			});
  		}
    }

  	ngOnInit( ){
		clearInterval( this.intervalo );
  		this.btnNext = this.elmRef.nativeElement.childNodes[0];
		this.btnPrev = this.elmRef.nativeElement.childNodes[1];
		this.currenUl = this.elmRef.nativeElement.childNodes[2];
  		if( this.currentConfig.init ){
  			this.fnInitSlider();

	  		if (isPlatformBrowser(this.platformId)){
	  			setTimeout(()=>{
		  			const currentConfig = this.currentConfig;

			  		$(this.currenUl).find('li:last-child').prependTo($(this.currenUl));

					$(this.btnPrev).bind('click', ()=>{						
						this.autoPlay = false;
						clearInterval( this.intervalo );
						this.fnPrev( this.currenUl );
					});

					$(this.btnNext).bind('click', ()=>{
						this.autoPlay = false;
						clearInterval( this.intervalo );
						this.fnNext( this.currenUl );
					});

					if( currentConfig.time > 0 ){
						this.intervalo = setInterval( ()=>{
							if( this.autoPlay ){
								this.fnNext( this.currenUl );
							}
						}, currentConfig.time);
					}

		  		});
			}
		}else{
			$(this.btnNext).off("click");
  			$(this.btnPrev).off("click");
		}
  	}

  	fnNext( currenUl ){
  		const currentConfig = this.currentConfig;
  		$(currenUl).animate({
  			left: - currentConfig.anchoItem
  		}, 300, function () {
  			$(currenUl).find('li:first-child').appendTo($(currenUl));
  			$(currenUl).css('left', '');
  		});
  	}

  	fnPrev( currenUl ){
  		const currentConfig = this.currentConfig;
  		$(currenUl).animate({
  			left: + currentConfig.anchoItem
  		}, 300, function () {
  			$(currenUl).find('li:last-child').prependTo($(currenUl));
  			$(currenUl).css('left', '');
  		});
  	}

  	fnInitSlider(){
  		if (isPlatformBrowser(this.platformId)){
  			setTimeout(()=>{
  				const currentConfig = this.currentConfig;
  				const currentSlider = $(this.elmRef.nativeElement);
	  			$(currentSlider).css({ height: currentConfig.alto });
	  			const currenUl = this.elmRef.nativeElement.childNodes[2];

	  			if( this.currentConfig.init && currentConfig.tipo !== "3" ){
	  				$(currenUl).css({ height: currentConfig.alto, width: currentConfig.anchoContent, marginLeft: - currentConfig.anchoItem });
	  			}else{
	  				$(currenUl).css({ height: currentConfig.alto, width: currentConfig.anchoContent });
	  			}

		  		if( currentConfig.tipo === "1" ){
					if (currentConfig.anchoItem >= 1201 && currentConfig.anchoItem < 1366) {
						currenUl.css({"height": "410px"});
						$(currenUl).find("li").css({"height": "410px"});
						$(currenUl).find("li section").css({"height": "410px"});
						$(currenUl).find("li section img").css({"height": currentConfig.alto});
					}else if (currentConfig.anchoItem >= 1024 && currentConfig.anchoItem <= 1200) {
						$(currenUl).css({"height": "325px"});
						$(currenUl).find("li").css({"height": "325px"});
						$(currenUl).find("li section").css({"height": "325px"});
						$(currenUl).find("li section img").css({"height": currentConfig.alto});
					} else if (currentConfig.anchoItem >= 768 && currentConfig.anchoItem <= 1023) {
						$(currenUl).css({"height": "245px"});
						$(currenUl).find("li").css({"height": "245px"});
						$(currenUl).find("li section").css({"height": "245px"});
						$(currenUl).find("li section img").css({"height": currentConfig.alto});
					} else if (currentConfig.anchoItem <= 767) {
						$(currenUl).css({"height": "435px"});
						$(currenUl).find("li").css({"height": "435px"});
						$(currenUl).find("li section").css({"height": "435px"});
						$(currenUl).find("li section img").css({"height": currentConfig.alto});
					}else if (currentConfig.anchoItem > 1366) {
						$(currenUl).css({"height": "406px"});
						$(currenUl).find("li").css({"height": "406px"});
						$(currenUl).find("li section").css({"height": "406px"});
						$(currenUl).find("li section img").css({"height": currentConfig.alto});
					} else {
						$(currenUl).css({"height": "460px"});
						$(currenUl).find("li").css({"height": "460px"});
						$(currenUl).find("li section").css({"height": "460px"});
						$(currenUl).find("li section img").css({"height": currentConfig.alto});
					}
					$(currenUl).find('li').css({ width: currentConfig.anchoItem });
		  			$(currenUl).find('li section').css({ width: currentConfig.ancho });

		  			// $(currenUl).find('li').css({ height: currentConfig.alto, width: currentConfig.anchoItem });
		  			// $(currenUl).find('li img').css({ height: currentConfig.alto, width: currentConfig.ancho });
		  		}else if( currentConfig.tipo === "2" ){
		  			$(currenUl).find('li').css({ height: currentConfig.alto, width: currentConfig.anchoItem });
		  			$(currenUl).find('li img').css({ height: currentConfig.alto, width: currentConfig.anchoItem });
		  		}else if( currentConfig.tipo === "3" ){
		  			var margin = 0;
		  			if( $("body").width() >= 768 ){
	  					margin = 20;
	  				}
		  			
		  			$(currenUl).find('li').css({ height: currentConfig.alto, width: currentConfig.anchoItem, marginLeft:margin});
		  			// $(currenUl).find('li:first-child').css({marginLeft:50});
		  		}else if( currentConfig.tipo === "4" ){
		  			$(currenUl).find('li').css({ height: currentConfig.alto, width: (currentConfig.anchoItem)});
		  		}

  			});


	  	}
  	}

}
